import { Satellite } from 'lucide-react';
import { apiPaths, type IssResponse } from '../../../shared/api/contract.ts';
import { DEFAULT_CITY } from '../../../shared/cities/index.ts';
import { FRESHNESS_POLICIES } from '../../../shared/freshness/index.ts';
import { SectionCard } from '../../components/SectionCard.tsx';
import { SkeletonRows } from '../../components/Skeleton.tsx';
import { useApi } from '../../hooks/useApi.ts';
import { formatDayTime, formatTime } from '../../lib/format.ts';
import { direction, passDuration } from './iss-format.ts';

export function IssPasses() {
  const iss = useApi<IssResponse>(apiPaths.iss(DEFAULT_CITY.slug), FRESHNESS_POLICIES.iss.refreshMs);
  return (
    <SectionCard
      title="Passages de la Station spatiale"
      icon={<Satellite size={20} aria-hidden="true" />}
      kind="iss"
      subject="de l’ISS"
      section={iss.data?.iss}
      loading={iss.loading}
      fetchError={iss.error}
      skeleton={<SkeletonRows rows={3} badge="round" />}
    >
      {(forecast) => (
        <>
          {forecast.passes.length === 0 ? (
            <p className="state-message">
              Aucun passage visible à l’œil nu dans les cinq prochains jours depuis Ermont.
            </p>
          ) : (
            <ul className="iss-list">
              {forecast.passes.map((pass) => (
                <li key={pass.startAt}>
                  <div className="iss-list__when">
                    <time dateTime={pass.startAt}>{formatDayTime(pass.startAt)}</time>
                    <span>
                      jusqu’à <time dateTime={pass.endAt}>{formatTime(pass.endAt)}</time>
                    </span>
                  </div>
                  <p className="iss-list__detail">
                    {passDuration(pass)} · {pass.maxElevationDeg}° au-dessus de l’horizon · du{' '}
                    {direction(pass.startAzimuthDeg)} vers le {direction(pass.endAzimuthDeg)}
                  </p>
                </li>
              ))}
            </ul>
          )}
          <p className="iss-note">
            Un passage n’est annoncé que s’il est réellement observable : station assez haute dans le ciel, nuit au sol,
            et station encore éclairée par le Soleil. Elle apparaît comme un point lumineux fixe qui traverse le ciel
            sans clignoter. Calcul d’Ermont Live à partir des éléments orbitaux publics, mis à jour le{' '}
            <time dateTime={forecast.elementsAt}>{formatDayTime(forecast.elementsAt)}</time>.
          </p>
        </>
      )}
    </SectionCard>
  );
}
